<template>
  <button
    v-if="basket.length > 0"
    class="cart-btn btn btn--green"
    @click="onOpenCart"
  >
    {{ priceFormat(resultPrice) }}
    <svg width="16" height="16">
      <use xlink:href="@/assets/icons/sprite.svg#cart"></use>
    </svg>
  </button>
  <SwipeModal v-show="isVisible" ref="bottomSheetRef">
    <Cart @onOpenResult="onOpenResult" @onCloseDetail="onCloseDetail" />
  </SwipeModal>

  <SwipeModal
    v-show="isVisibleResult"
    ref="bottomSheetResultRef"
    @onClose="onCloseResult"
  >
    <OrderResult />
  </SwipeModal>
</template>
<script setup lang="ts">
  import { computed, onMounted, onUnmounted, ref } from "vue";
  import SwipeModal from "./SwipeModal.vue";
  import Cart from "./Cart.vue";
  import OrderResult from "./OrderResult.vue";
  import { priceFormat } from "@/helpers/priceFormat";
  import { eventBus } from "@/helpers/eventBus";
  import { IProduct } from "@/models/models";

  const bottomSheetRef = ref<InstanceType<typeof SwipeModal>>();

  const bottomSheetResultRef = ref<InstanceType<typeof SwipeModal>>();

  const isVisible = ref<boolean>(false as boolean);

  const isVisibleResult = ref<boolean>(false as boolean);

  const onOpenCart = async () => {
    isVisible.value = true;
    setTimeout(() => {
      bottomSheetRef.value?.open();
    }, 200);
  };

  const onCloseDetail = () => {
    bottomSheetRef.value?.close();
    setTimeout(() => {
      isVisible.value = false;
    }, 200);
  };

  const onOpenResult = async () => {
    isVisibleResult.value = true;
    onCloseDetail();
    setTimeout(() => {
      bottomSheetResultRef.value?.open();
      basket.value = [];

      localStorage.setItem("basket", JSON.stringify(basket.value));

      eventBus.emit("cart-clear", {});
    }, 200);
  };

  const onCloseResult = () => {
    isVisibleResult.value = false;
  };

  let basket = ref<Array<IProduct>>(JSON.parse(localStorage.getItem("basket") || "[]"));

  const resultPrice = computed(() => {
    let sum = 0;

    basket.value.forEach((item: IProduct) => {
      sum += item.count * item.basePrice;
    });

    return sum;
  });

  const updateCart = () => {
    basket.value = JSON.parse(localStorage.getItem("basket") || "[]");
  };

  const clerCart = () => {
    basket.value = JSON.parse(localStorage.getItem("basket") || "[]");
  };

  eventBus.on("cart-updated", updateCart);

  eventBus.on("cart-clear", clerCart);

  onMounted(() => {
    window.addEventListener("storage", updateCart);
  });

  onUnmounted(() => {
    window.removeEventListener("storage", updateCart);
  });
</script>
<style scoped lang="scss"></style>
